// Gallery Slider
import Splide from '@splidejs/splide';
import { delegate } from './lib';

const body = find('body');
const galleries = findAll('.gallery');
let mainSplide, thumbnailsSplide;


galleries.forEach((gallery) => {

    /*
    1. get images
    2. create hidden overlay at the end of the document
    3. create splide html inside the overlay
    4. show overlay for a gallery when clicking on an image in this gallery
    5. init splide sliders (one main slider with prev/next buttons, one navigation slider below with thumbnails
     */

    let galleryId = gallery.getAttribute('class').match(/gallery-(\d+)/);
    if (!galleryId) {
        galleryId = Math.floor(Math.random() * 1000000); // generate a random id if not found
    } else {
        galleryId = galleryId[1];
    }
    gallery.setAttribute('data-id', galleryId);

    const imageFigures = gallery.findAll('.image-wrap.gallery-image');


    let mainImages = [];
    let thumbnailImages = [];
    imageFigures.forEach((imgFigure) => {
        const img = imgFigure.find('img');
        const src = img.getAttribute('src');
        const srcset = img.getAttribute('srcset');
        const fullSrc = img.getAttribute('data-full-src') || src;
        const fullSrcset = img.getAttribute('data-full-srcset');
        const captionEl = imgFigure.find('.caption');
        const caption = captionEl ? captionEl.textContent.trim() : null;



        // get closest size to 540w
        let thumbnailSrc;
        if (srcset) {
            const srcsetItems = srcset.split(',').map(item => {
                const [url, size] = item.trim().split(' ');
                return {
                    url,
                    width: parseInt(size) || 0
                };
            });

            // Find closest to 540w (prefer larger if equal distance)
            const closest = srcsetItems.reduce((prev, curr) => {
                const prevDiff = Math.abs(prev.width - 540);
                const currDiff = Math.abs(curr.width - 540);
                if (currDiff < prevDiff || (currDiff === prevDiff && curr.width > prev.width)) {
                    return curr;
                }
                return prev;
            });

            thumbnailSrc = closest.url;
        }



        if (!thumbnailSrc) {
            thumbnailImages.push(src);
        } else {
            thumbnailImages.push(thumbnailSrc);
        }


        imgFigure.classList.add('gallery-image');

        mainImages.push({
            src: fullSrc,
            srcset: fullSrcset,
            caption: caption
        });
    });




    let mainSlidesHTML = '';
    mainImages.forEach((image) => {
        const srcsetAttr = image.srcset ? ` srcset="${image.srcset}"` : '';
        const captionHtml = image.caption ? `<div class="caption">${image.caption}</div>` : '';
        mainSlidesHTML += `
            <li class="splide__slide slide">
                <img data-lazy-src="${image.src}"${srcsetAttr ? srcsetAttr.replace('srcset=', 'data-lazy-srcset=') : ''} alt="Main Image" data-sizes="100cqw" />
                ${captionHtml}
            </li>
        `;
    });
    let thumbnailSlidesHTML = '';
    thumbnailImages.forEach((image) => {
        thumbnailSlidesHTML += `
            <li class="splide__slide slide">
                <img src="${image}" alt="Thumbnail" />
            </li>
        `;
    });

    let galleryHTML = `
    <div class="gallery-slider">
        <div class="inner">
            <div class="top">
                <div class="splide main-slider">
                    <div class="splide__track">
                        <ul class="splide__list">
                            ${mainSlidesHTML}
                        </ul>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="splide thumbnail-slider">
                    <div class="splide__track">
                        <ul class="splide__list">
                            ${thumbnailSlidesHTML}
                        </ul>
                    </div>
                </div>                
            </div>
        </div>
        <a href="#" class="close"><div class="inner"></div></a>
    </div>
    `;

    // append to end of body
    const overlay = document.createElement('div');
    overlay.classList.add('gallery-slider-overlay');
    overlay.setAttribute('data-id', galleryId);
    overlay.innerHTML = galleryHTML;
    document.body.appendChild(overlay);

});

function activateLazyImages(galleryOverlay) {
    if (galleryOverlay.dataset.imagesActivated) return;
    galleryOverlay.querySelectorAll('img[data-lazy-src]').forEach((img) => {
        img.setAttribute('src', img.getAttribute('data-lazy-src'));
        img.removeAttribute('data-lazy-src');
        const srcset = img.getAttribute('data-lazy-srcset');
        if (srcset) {
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-lazy-srcset');
        }
        const sizes = img.getAttribute('data-sizes');
        if (sizes) {
            img.setAttribute('sizes', sizes);
            img.removeAttribute('data-sizes');
        }
    });
    galleryOverlay.dataset.imagesActivated = '1';
}

function showGallery(id, imageIndex) {
    const galleryOverlay = find(`.gallery-slider-overlay[data-id="${id}"]`);
    if (!galleryOverlay) {
        return;
    }
    galleryOverlay.classList.add('active');
    activateLazyImages(galleryOverlay);
    initSplide(galleryOverlay);
    gotoSlide(galleryOverlay, imageIndex);
}

function hideAllGalleries() {
    const allGalleries = findAll('.gallery-slider-overlay');
    allGalleries.forEach((gallery) => {
        gallery.classList.remove('active');
    });
}

function initSplide(galleryOverlay) {
    
    const mainSlider = galleryOverlay.find('.main-slider');
    const thumbnailSlider = galleryOverlay.find('.thumbnail-slider');
    
    if (mainSlider && thumbnailSlider) {
        mainSplide = new Splide(mainSlider, {
            type: 'slide',
            pagination: false,
            arrows: true,
            wheel: true,
        });

        thumbnailsSplide = new Splide(thumbnailSlider, {
            rewind: true,
            fixedWidth: 100,
            fixedHeight: 75,
            gap: 20,
            isNavigation: true,
            focus: 'center',
            pagination: false,
            arrows: false,
            wheel: true,
            cover: true,
            updateOnMove: true,
            padding: {left: 20, right: 20},
        });

        mainSplide.sync(thumbnailsSplide);
        mainSplide.mount();
        thumbnailsSplide.mount();
    }
}

function gotoSlide(galleryOverlay, index) {
    const originalMainSpeed = mainSplide.options.speed;
    mainSplide.options.speed = 0;
    const originalThumbnailSpeed = thumbnailsSplide.options.speed;
    thumbnailsSplide.options.speed = 0;

    mainSplide.go(index);
    thumbnailsSplide.go(index);
    mainSplide.options.speed = originalMainSpeed;
    thumbnailsSplide.options.speed = originalThumbnailSpeed;


}

// open slider
delegate('click', '.image-wrap.gallery-image', (ev) => {
    ev.preventDefault();

    const gallery = ev.target.closest('.gallery');
    const galleryId = gallery.getAttribute('data-id');

    let imageIndex = Array.from(gallery.querySelectorAll('.image-wrap.gallery-image')).indexOf(ev.target.closest('.image-wrap.gallery-image'));

    hideAllGalleries(); // hide all galleries first
    body.classList.add("gallery-slider-overlay-open"); // to add overflow: hidden etc.
    showGallery(galleryId, imageIndex); // show the gallery for the clicked image
});

// close slider
delegate('click', '.gallery-slider-overlay .close', (ev) => {
    ev.preventDefault();
    
    const galleryOverlay = ev.target.closest('.gallery-slider-overlay');
    if (galleryOverlay) {
        galleryOverlay.classList.remove('active');
        body.classList.remove("gallery-slider-overlay-open");
    }
});